import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { usePageView } from "src/hooks/use-page-view";
import { paths } from "src/paths";

export const Route = createFileRoute("/_authenticated/conta/notificacoes/")({
  component: () => <Page />,
});

const Page = () => {
  const navigate = useNavigate();

  usePageView();

  useEffect(() => {
    navigate({ to: paths.dashboard.account.general, replace: true });
  }, [navigate]);

  return null;
};
